import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";

import { Button, Chip, Typography, Box, Alert } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { formatDate } from "../../helper";
import { useNavigate } from "react-router-dom";
import * as Constants from '../../Constants';


export default function UsersTable() {
  const [userData, setUserData] = React.useState([]);
  const [selectedUser, setSelectedUser] = React.useState();
  const [buttonHidden, setButton] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [filteredRows, setFilteredRows] = React.useState([]);


  const [isLoading, setIsLoading] = React.useState(true);

  const navigate = useNavigate();

  function filterRowsByNextThreeMonths(rows) {
    const today = new Date();
    const threeMonthsLater = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());

    const filteredRows = rows.filter((row) => {
      const rowDateParts = row.endDate.split('-');
      const rowDate = new Date(rowDateParts[2], rowDateParts[1] - 1, rowDateParts[0]); // Subtract 1 since months are zero-indexed
      return rowDate <= threeMonthsLater;
    });
    return filteredRows;
  }

  const handleEvent = (
    params, // GridRowParams
    event, // MuiEvent<React.MouseEvent<HTMLElement>>
    details // GridCallbackDetails
  ) => {
    setSelectedUser(params.row);
    setButton(true);
  };

  const columns = [
    {
      field: "username",
      headerName: "Username",
      renderCell: ({ row: { username } }) => {
        return (
          <Box
            sx={{ p: "1px 7px 1px 7px" }}
            borderRadius="15%"
            className="userNameBox"
          >
            <Typography className="theUserNames">{username}</Typography>
          </Box>
        );
      },
    },
    { field: "name", headerName: "Name", minWidth: 150, flex: 1 },
    { field: "company", headerName: "Company", minWidth: 150, flex: 1 },
    { field: "email", headerName: "E-mail", minWidth: 200, flex: 2 },
    {
      field: "accountType",
      headerName: "Account type",
      align: "center",
      headerAlign: "center",
      renderCell: ({ row: { accountType } }) => {
        return (
          <>
            {accountType === "plus" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#6a1b9a",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "view" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#2196f3",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "free" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#ff9800",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "admin" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#009688",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {accountType === "standard" && (
              <Chip
                label={accountType}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#01579b",
                  ml: "5px",
                  mt: "5px",
                  fontSize: "1em",
                }}
              />
            )}
          </>
        );
      },
    },
    {
      field: "mfaKey",
      headerName: "MFA?",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      renderCell: ({ row: { mfaKey } }) => {
        return (
          <Box display="flex" justifyContent="center">
            <CancelRoundedIcon fontSize="small" sx={{ color: "#f44336" }} />
          </Box>
        );
      },
    },

    {
      field: "state",
      headerName: "State",
      align: "center",
      headerAlign: "center",
      flex: 0.9,
      renderCell: ({ row: { state } }) => {
        return (
          <>
            {state === "Active" && (
              <Chip
                label={state}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#4caf50",
                  ml: "5px",
                  fontSize: "1em",
                }}
              />
            )}
            {state !== "Active" && (
              <Chip
                label={state}
                sx={{
                  fontWeight: "Bold",
                  backgroundColor: "#f44336",
                  ml: "5px",
                  fontSize: "1em",
                }}
              />
            )}
          </>
        );
      },
    },
    { field: "endDate", headerName: "Expiry" },
  ];

  React.useEffect(() => {
    axios.defaults.withCredentials = true 
    axios.get(`${Constants.API_URL}/users`).then((res) => {
      const users = res.data.users;
      users.map((user) => {
        user.endDate = formatDate(user.endDate);
      });
      setUserData(users);
      setFilteredRows(filterRowsByNextThreeMonths(users))
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <Box m="10px" sx={{ backgroundColor: "#212121", p: "20px" }}>
        {alert ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="success"
          >
            {alertContent}
          </Alert>
        ) : (
          <></>
        )}
        {alert === "error" ? (
          <Alert
            onClose={() => {
              setAlert(false);
            }}
            severity="error"
          >
            There was an error when adding user!
          </Alert>
        ) : (
          <></>
        )}

        <Box>
          <DataGrid
            loading={isLoading}
            autoHeight
            autoWidth
            getRowId={(row) => row.username}
            rows={filteredRows}
            columns={columns}
            onRowClick={handleEvent}
            initialState={{
              filter: {
                filterModel: {
                  items: [
                    {
                      columnField: "state",
                      operatorValue: "equals",
                      value: "Active",
                    }
                  ],
                },
              }
            }}
          />
        </Box>

                {/* Opens modal to add new user */}
                <Box sx={{ display: "flex", justifyContent: "right", pt: "px"}}>

          {buttonHidden && (
            <Button
              variant="contained"
              sx={{ ml: "5px", mt: "10px" }}
              onClick={() => navigate(`/users/${selectedUser.username}`)}
            >
              {" "}
              Edit user: {selectedUser.name}
            </Button>
          )}
        </Box>

      </Box>
    </>
  );
}
